import BottomSheet from '../bottom-sheet/BottomSheet';
import { closeLocationSelector, locationSelector$ } from '../../utils/location';
import { FormattedMessage } from 'react-intl';
import { LocationHelperTexts } from '../../types/autocomplete';
import { LocationSelectError } from '../location-select-error/LocationSelectError';
import { LocationSelector } from '../../types/location';
import { Subject } from 'rxjs';
import { useEffect, useState } from 'react';
import {
  CloseButton,
  CloseIcon,
  CurrentLocation,
  CurrentLocationWrapper,
  HelperText,
  LocationAutocomplete,
  LocationLabel,
  Menu,
  SearchIcon,
  TopBar,
} from './LocationBottomSheetStyle';

const focusInput = new Subject<boolean>();

function LocationBottomSheet() {
  const [open, setOpen] = useState<boolean>(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState<boolean>(false);

  const helperText: LocationHelperTexts = {
    default: {
      element: (
        <HelperText>
          <FormattedMessage id='generic.locationHelperTexts.default' />
        </HelperText>
      ),
    },
    invalidInput: {
      element: (
        <HelperText hasError>
          <FormattedMessage id='generic.locationHelperTexts.invalidLocation' />
        </HelperText>
      ),
    },
  };

  const unhandledClicks = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    event.stopPropagation();
  };

  const onTopBarClick = () => {
    focusInput.next(false);
  };

  useEffect(() => {
    const subscription = locationSelector$.subscribe((e) => {
      setOpen(e === LocationSelector.BOTTOM_SHEET ? true : false);
    });
    return () => subscription.unsubscribe();
  }, []);

  return (
    <BottomSheet isOpen={open} onClose={closeLocationSelector}>
      <Menu className='location-bottomsheet-menu' onClick={unhandledClicks}>
        <TopBar onClick={onTopBarClick}>
          <LocationLabel>Where is your jobsite?</LocationLabel>
          <CloseButton onClick={closeLocationSelector}>
            <CloseIcon></CloseIcon>
          </CloseButton>
        </TopBar>
        <LocationAutocomplete
          resetCurrentLocationOnClickAway={false}
          hideStartIcon={true}
          endIcon={<SearchIcon />}
          popupPosition='relative'
          helperText={helperText}
          onDropdownToggleFn={setIsDropdownOpen}
          inputFocusSubject={focusInput}
        />
        {!isDropdownOpen && (
          <CurrentLocationWrapper>
            <LocationSelectError />
            <CurrentLocation />
          </CurrentLocationWrapper>
        )}
      </Menu>
    </BottomSheet>
  );
}

export default LocationBottomSheet;
